// extracted by mini-css-extract-plugin
export default {"gallery-setting":"App_gallery-setting__ZV9Hc","sec-title":"App_sec-title__qcFcM","trd-title":"App_trd-title__-KnSB","T3Modules":"App_T3Modules__xazxG"};